import { Avatar, type AvatarProps } from '@mantine/core'

interface Props extends Omit<AvatarProps, 'color' | 'children' | 'src' | 'name'> {
  name?: string | null
  email?: string | null
}

/**
 * Teal-tinted square avatar with initials, matching Metarina customer avatar style.
 * Falls back to email first char if no name, then '?'.
 */
export function CustomerAvatar({ name, email, radius = 'xl', size = 40, ...rest }: Props) {
  const initials = getInitials(name, email)
  return (
    <Avatar
      radius={radius}
      size={size}
      color="navy"
      variant="filled"
      styles={{
        placeholder: {
          backgroundColor: 'var(--mantine-primary-color-9)',
          color: 'white',
          fontWeight: 600,
        },
      }}
      {...rest}
    >
      {initials}
    </Avatar>
  )
}

function getInitials(name?: string | null, email?: string | null): string {
  const source = (name || email || '').trim()
  if (!source) return '?'
  const parts = source.split(/\s+|[._-]/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}
